import { useState, useCallback, useEffect } from 'react';
import { api } from '../utils/api';

export interface DcMeta {
  code: string;
  name: string;
  rows_count: number;
  max_racks_per_row: number;
  routing_strategy: string;
}

export function useAdminDatacenters() {
  const [dcs, setDcs] = useState<DcMeta[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadDcs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await api.get('/api/datacenters');
      setDcs(r.data);
    } catch (e: any) {
      setError(e.response?.data?.detail || e.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadDcs();
  }, [loadDcs]);

  return { dcs, loading, error, refresh: loadDcs };
}
